import React, { useEffect, useState } from 'react';
import { Game } from '../../types/types';
import { GridColDef, GridCellParams, GridRowParams, GridEvents, MuiEvent, GridCallbackDetails, GridRenderCellParams } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Player } from '../../types/types';
import { AddPlayer } from '../../state/reducers/ChosenPlayersReducer';
import { useAppSelector, useAppDispatch } from '../../hooks';
import { GMobiledata } from '@mui/icons-material';
import PlayerDataGrid from '../DataGrid/PlayerDataGrid';
import { TeamLogos, TeamsList } from '../../globals/Globals';
import { useNavigate } from 'react-router-dom';


export interface Props {
    games: Game[];
}

const columns:GridColDef[]  = [
    {field: "name", headerName: "Name", width: 130},
    { field: 'team', headerName: 'Team', width: 130,
        renderCell: (params: GridRenderCellParams<Date>) => (<div style={{display: "flex", width: '100%', height: '38px', alignItems: 'center', background: `linear-gradient(120deg, ${params.row.oppositioncolors[0]} 0%, ${params.row.oppositioncolors[0]} 50%, ${params.row.oppositioncolors[1]} 50%)`, color: "white"}}>
            <img style={{height: "1.5rem", width: "2rem"}}src={params.row.teamlogo} alt="Team logo"/>
            <p>{params.row.team}</p>
        </div>)
    },
    { field: 'positionString', headerName: 'Position'},
    
    { field: "posrdrank", headerName: "Pos RD Rnk"},
    { field: "postotalrank", headerName: "Pos Total Rnk"},
    { field: 'points', headerName: 'Points', type: "number" },
    { field: 'addbutton', headerName: '' ,renderCell: (params: GridRenderCellParams<Date>) => (
        <AddIcon />)
    },
]


function SingleMatchTable({games}:Props) {
    let router = useNavigate();
    const dispatch = useAppDispatch();

    const [ players, setPlayers ] = useState<Player[]>([]);
    const [ rows, setRows ] = useState<object[]>([]);

    useEffect(() => {
        PopulateRows();
    }, [games]);

    const onRowClick = (grid: GridRowParams) => {
        return 1
    } 

    const onCellClick = (params: GridCellParams, event: MuiEvent<React.MouseEvent>, details: GridCallbackDetails) => {
        if (params.field !== 'addbutton') {
            router('/player/'+params.row.playerid);
        } else {
            let player:Player = {id:"",firstname:"",lastname:"", pic: '', position: {name: ""},stats: [{last5Games: [], timestamp:"", avgpts: 0, avgbase: 0, ppm: 0 }], positionrank: [], positions: [], ownerships: []};
            players.map(function(p) {
                if (p.id === params.row.id) {
                    player = p;
                }
            });
            dispatch(AddPlayer(player));
        }
    }
// tackles, tries, hit ups, missed tackles, errors,
    const PopulateRows = () => {
        let newrows:object[] = [];
        games?.map(function(game) {
            console.log("Error Game: ", game);
            if (game.player.length > 0) {    
                let playername:string = '';
                let playerid = 1;
                if (game.player.length > 0) {
                    playername = game.player[0].firstname + ' ' + game.player[0].lastname;
                    playerid = game.player[0].id;
                }
                let teamlogo:string = TeamLogos[game.team.name ? game.team.name : ''];
                let oppositioncolors:string[] = TeamsList[game.team.name ? game.team.name : ''];
                let positionString = '';
                
                let positionsarray = game.positions.map(function(position) {
                    return position.name;
                });
                positionString = positionsarray.join(", ");
                
                newrows.push({
                    id: game.id,
                    name: playername,
                    positions: positionString,
                    team: game.team.name,
                    teamlogo: teamlogo,
                    points: game.points,
                    oppositioncolors: oppositioncolors,
                    playerid: playerid,
                    posrdrank: game.posrdrank,
                    postotalrank: game.posrank,
                    positionString: positionString,
                });
            }
        });
        setRows(newrows);
    }
    return <PlayerDataGrid height={"90vh"} rows={rows} columns={columns} onRowClick={onRowClick} onCellClick={onCellClick} />
}  

export default SingleMatchTable;